import { memo, type CSSProperties, type ReactNode } from 'react'
import WidgetbarPageShell from './WidgetbarPageShell'

type Props = {
    children: ReactNode
    blur?: boolean
}

const panelStyle = (blur?: boolean): CSSProperties => ({
    gridArea: 'widgetbar-pages',
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    ...(blur ? { filter: 'blur(4px)', pointerEvents: 'none' } : {}),
})

/** Named wrapper so DevTools does not only show anonymous div under widgetbar-pages. */
function WidgetbarPagesPanel({ children, blur }: Props) {
    return (
        <div className="widgetbar-pages" style={panelStyle(blur)} data-widgetbar-pages>
            <WidgetbarPageShell>{children}</WidgetbarPageShell>
        </div>
    )
}

WidgetbarPagesPanel.displayName = 'WidgetbarPagesPanel'

export default memo(WidgetbarPagesPanel)
